export default __webpack_public_path__ + "static/media/scan-bg.a900d493.svg";